import React, {Component} from "react";
import Strings from "../../config/Strings";
import {BackButton} from "../../global/tiger-button/BackButton";
import {TigerSpinner} from "../../global/tiger-spinner/TigerSpinner";
import {withToast} from "../../util/ToastService";
import GlobalConstants from "../../config/GlobalConstants";
import './Premium.scss';
import {GetDiscountCodes, GetPremiumAccessFeatureByPlanVariantId} from "../subscriptions/SubscriptionService";
import TicketAccess from "./premium-types/TicketAccess";
import ShopSubscriptionAccess from "./premium-types/ShopSubscriptionAccess";
import IAPAccess from "./premium-types/IAPAccess";
import './premium-types/PremiumType.scss';
import {GetActiveBillwerkContractsOfCustomer} from "../dashboard/DashboardService";
import {GetBillwerkAccountByOwner} from "./PremiumService";
import {getPremiumAccessFeatureData} from "../forms/purchase/subscription/SubscriptionPurchaseUtils";
import {FindActiveAndValidNowByAccount} from "../premiumAccess/PremiumAccessService";
import {TigerButton} from "../../global/tiger-button/TigerButton";
import {InfoModal} from "../../global/ConfirmationModal";
import {FaInfoCircle} from "react-icons/fa";
import {EmailConfirmationHint} from "../dashboard/EmailConfirmationHint";

class Premium extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            forceProductsView: false,
            forceTicketView: false,
            forceInvoicesView: false,
            isIap: false,
            isTicket: false,
            contract: null,
            isAnnualBilling: true,
            selectedPlan: null,
            purchasablePremiumAccessFeatures: null,
            currentPlanVariantId: null,
            currentPremiumAccessFeature: null,
            showBillingPeriodToggleYear: true,
            showBillingPeriodToggleMonth: true,
            showContractInfo: false,
            contractInfo: null,
            discountCodes: [],
        };

        document.title = "Mein Zugang :: tiger.media";
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.accountId !== this.props.accountId) {
            await this.loadPremiumData();
        }
    }

    async componentDidMount() {
        await this.loadPremiumData();
    }

    async loadPremiumData() {
        this.setState({loading: true});
        if (this.props.accountId != null) {
            await this.loadBillwerkContract();
            await this.loadPremiumAccessData();
            await this.loadCurrentActivePremiumAccessFeature();
            await this.loadPurchaseablePremiumAccessFeatures();
            await this.loadDiscountCodes();
        }
        this.setState({loading: false});
    }

    async loadBillwerkContract() {
        let contract = null;
        const contractsRes = await GetActiveBillwerkContractsOfCustomer();
        if (!contractsRes.error && contractsRes.result.length > 0) {
            contract = contractsRes.result[0];
        }

        this.setState(prevState => ({
            ...prevState,
            contract: contract,
        }));
    }

    async loadPremiumAccessData() {
        let filter = {
            page: 0,
        };
        let response = await FindActiveAndValidNowByAccount(this.props.accountId, filter);
        if (!response.error) {
            const result = response.result;
            let premiumAccess = result.length > 0 ? result[0] : null;
            const currentPlanVariantId = premiumAccess?._embedded?.features?.planVariantId;
            const isActive = premiumAccess != null;
            const isAppleIap = isActive && premiumAccess?.source?.type === 'APPLE';
            const isGoogleIap = isActive && premiumAccess?.source?.type ==='_GOOGLE';
            const isIap = isAppleIap || isGoogleIap;
            const isTicket = isActive && !isIap && premiumAccess?.type === 'TIGERTICKET';

            this.setState(prevState => ({
                ...prevState,
                currentPlanVariantId: currentPlanVariantId,
                isIap: isIap,
                isTicket: isTicket
            }));
        }

    }

    async loadCurrentActivePremiumAccessFeature() {
        const result = await GetPremiumAccessFeatureByPlanVariantId(this.state.currentPlanVariantId);
        if (result.error) {
            return;
        }

        const currentPremiumAccessFeatureResult = result.result;
        let  currentPremiumAccessFeature = this.addCalculatedPrice(currentPremiumAccessFeatureResult);

        if (currentPremiumAccessFeature) {
            this.setState({
                currentPremiumAccessFeature: {
                    ...currentPremiumAccessFeature,
                    isTicket: this.state.isTicket
                }
            });
        }
    }

    async loadDiscountCodes() {
        if (this.props.accountId != null) {
            const discountCodes = await GetDiscountCodes(this.props.accountId);
            if (!discountCodes.error) {
                this.setState((prevState) => ({
                    ...prevState,
                    discountCodes: discountCodes.result?._embedded?.discounts
                }));
            }
        }
    }

    async loadPurchaseablePremiumAccessFeatures() {
        let country = 'DE'
        if (!this.state.contract?.PaymentBearer?.Country) {
            if (this.props.accountId) {
                let response = await GetBillwerkAccountByOwner(this.props.accountId);
                if (response?.result && !response.error && response?.result?.Address) {
                    country = response?.result?.Address?.Country;
                }
            }
        } else {
            country = this.state.contract.PaymentBearer.Country;
        }

        let filter = {
            app: "TIGERTONES",
            platform: "WEB",
            territory: country,
            initialPurchaseMyTigerEnabled: true
        }

        let purchasablePremiumAccessFeatures = await getPremiumAccessFeatureData(this.props.accountId, filter);
        purchasablePremiumAccessFeatures = [
            ...purchasablePremiumAccessFeatures[0],
            //Folgetarife (downgrades)
            // ...purchasablePremiumAccessFeatures[1]
        ];

        purchasablePremiumAccessFeatures = purchasablePremiumAccessFeatures.map(feature =>
            this.addCalculatedPrice(feature)
        );

        const selectedPlan = this.getPlanWithHighestPrice(purchasablePremiumAccessFeatures);

        const [showBillingPeriodToggleYear, showBillingPeriodToggleMonth, isAnnualBilling] =
            this.getShowBillingPeriodToggle(purchasablePremiumAccessFeatures);

        this.setState(() => ({
            purchasablePremiumAccessFeatures: purchasablePremiumAccessFeatures,
            isAnnualBilling: isAnnualBilling,
            showBillingPeriodToggleYear: showBillingPeriodToggleYear,
            showBillingPeriodToggleMonth: showBillingPeriodToggleMonth,
            selectedPlan: selectedPlan,
        }));
    }

    addCalculatedPrice(premiumAccessFeature) {
        if(premiumAccessFeature) {
            const recurringFee = Number(premiumAccessFeature?._embedded?.planVariant?.RecurringFee) || 0;
            const currency = premiumAccessFeature?._embedded?.planGroup?.Currency ?? "";
            const unit = premiumAccessFeature?._embedded?.planVariant?.ContractPeriod?.unit;
            const isYearly = unit === "year";
            const priceAsNumber = isYearly ? recurringFee / 12 : recurringFee;
            const price = priceAsNumber.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            const priceInfo = isYearly
                ? `mtl. ${recurringFee.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency} / jährl. Zahlung`
                : `mtl.` ;

            return {
                ...premiumAccessFeature,
                locallyCalculatedFields: {
                    price,
                    currency,
                    priceInfo
                }
            };
        }
    }

    getShowBillingPeriodToggle(premiumAccessFeatures) {
        let showBillingPeriodToggleYear = false;
        let showBillingPeriodToggleMonth = false;
        let isAnnualBilling = false;
        for (let key in premiumAccessFeatures) {
            const premiumAccessFeature = premiumAccessFeatures[key];
            if (premiumAccessFeature._embedded?.planVariant?.ContractPeriod?.unit === "year") {
                showBillingPeriodToggleYear = true;
                isAnnualBilling = true;
            }
            if(premiumAccessFeature._embedded?.planVariant?.ContractPeriod?.unit === "month") {
                showBillingPeriodToggleMonth = true;
            }
        }
        return [showBillingPeriodToggleYear, showBillingPeriodToggleMonth, isAnnualBilling];
    }

    getPlanWithHighestPrice(premiumAccessFeaturesData) {
        let highestPrice = 0;
        let planIdWithHighestPrice = null;
        for (let key in premiumAccessFeaturesData) {
            const premiumAccessFeature = premiumAccessFeaturesData[key];
            let price = premiumAccessFeature._embedded?.planVariant?.RecurringFee;
            if (price > highestPrice) {
                planIdWithHighestPrice = premiumAccessFeature.planVariantId;
                highestPrice = price;
            }
        }
        return planIdWithHighestPrice;
    }

    async purchasePlanVariant(e) {
        e.preventDefault();
        let planVariantId = this.state.selectedPlan;
        sessionStorage.setItem('ls.accountId', JSON.stringify(this.props.accountId));
        this.props.history.push("/" + GlobalConstants.APP_PATH + "purchase/" + planVariantId)
    }

    premiumContentByType() {
        if (this.state.forceTicketView) {
            return (
                <div id="premiumAnchor">
                    <TicketAccess
                        // subscription={this.state.subscription}
                        accountId={this.props.accountId}
                        history={this.props.history}/>
                    {this.footerByType(false, !this.state.isTicket, true)}
                </div>
            );
        }

        //Open the view depending on the active subscription
        // let subscription = this.state.subscription;
        if (this.state.isTicket) {
            //Ticket
            return (
                <div id="premiumAnchor">
                    <TicketAccess
                        // subscription={subscription}
                        accountId={this.props.accountId}
                        history={this.props.history}/>
                    {this.footerByType(false, false, true)}
                </div>
            );
        } else if (this.state.isIap) {
            //IAP
            return (
                <div id="premiumAnchor">
                    <IAPAccess
                        // subscription={subscription}
                        accountId={this.props.accountId}
                        history={this.props.history}/>
                    {this.footerByType(true, false, true)}
                </div>
            );
        } else {
            //Billwerk subscription
            return (
                <div id="premiumAnchor">
                    <ShopSubscriptionAccess
                        accountId={this.props.accountId}
                        contract={this.state.contract}
                        // subscription={this.state.subscription}
                        history={this.props.history}/>
                    {this.footerByType(true, false, true)}
                </div>
            );
        }
    }

    footerByType(showTicketsLink, showCurrentType, showPremiumProducts) {
        return (
            <>
                <hr/>
                {showPremiumProducts &&
                    <>
                        <div onClick={() => {
                            this.setState(prevState => ({
                                ...prevState,
                                forceTicketView: false,
                                forceProductsView: true
                            }));
                            window.scrollTo(0, 0);
                        }}
                             className="premium-footer-link">
                            {Strings.PREMIUM_SHOW_PRODUCTS_LINK}&#187;
                        </div>
                        <a href={"/ticket"} className="premium-footer-link">
                            {Strings.PREMIUM_SHOW_TICKET_REDEMPTION_LINK}&#187;
                        </a>
                    </>
                }
                {showCurrentType &&
                    <div onClick={() => {
                        this.setState(prevState => ({
                            ...prevState,
                            forceTicketView: false,
                            forceProductsView: false
                        }));
                        window.scrollTo(0, 0);
                    }}
                         className="premium-footer-link"
                    >
                        {Strings.PREMIUM_SHOW_CURRENT_TYPE}&#187;
                    </div>
                }
                {showTicketsLink &&
                    <div onClick={() => {
                        this.setState(prevState => ({
                            ...prevState,
                            forceTicketView: true,
                            forceProductsView: false
                        }));
                        window.scrollTo(0, 0);
                    }}
                         className="premium-footer-link"
                    >
                        {Strings.PREMIUM_SHOW_ALL_TICKETS_LINK}&#187;
                    </div>
                }
            </>
        );
    }

    closeView = () => {
        this.props.history.push({
            pathname: "/" + GlobalConstants.APP_PATH,
            state: this.state.profileLink
        })
    }

    invoicesAndPaymentsLinkSection() {
        return <div id={"payment-link"}>
            <h4 className={"mt-4"}>Zahlungen & Rechnungen</h4>
            <p>Verwalte hier deine Zahlungsdaten und siehe deine Rechnungen ein.</p>
            <div className={"mt-2"} id={"payment-link-button"} >
                <a href={"/premium/settings"} style={{textDecoration: "none"}}>
                    <TigerButton variant={"orange"} design={"small-height"} hover={false}>Zahlungsdaten verwalten</TigerButton>
                </a>
            </div>
        </div>
    }


    currentActivePremiumAccessFeature() {
        return (
            <div className="card" id={"current-access-card"}>
                <div>
                    <h4>{Strings.PURCHASE_TARIF_CURRENT_TARIF}</h4>
                </div>
                <div className={"card-grid"} id={"current-plan-card-and-payment-link"}>
                    {this.state.currentPremiumAccessFeature ?
                    <div className="plan" id={"current-plan-card"}
                                             style={{backgroundColor: this.state.currentPremiumAccessFeature?.frontendDesign?.backgroundColor}}
                                             key={this.state.currentPremiumAccessFeature?.id}
                                             onClick={() => this.setState({selectedPlan: this.state.currentPremiumAccessFeature?.planVariantId})}>
                        <div>
                            {this.state.currentPremiumAccessFeature?.frontendDesign?.headerImage &&
                                <img
                                    src={this.state.currentPremiumAccessFeature?.frontendDesign?.headerImage}
                                    className="plan-image"
                                    alt={"plan-image"}/>
                            }
                        </div>
                        <div style={{color: this.state.currentPremiumAccessFeature?.frontendDesign?.textColor}}
                             dangerouslySetInnerHTML={{
                                 __html: this.state.currentPremiumAccessFeature?.checkoutDescription ?? ""
                             }}
                        />
                        {!this.state.currentPremiumAccessFeature?.isTicket && (
                            <div className="purchase-price">
                                <div className="purchase-price-line"
                                     style={{
                                         color: this.state.currentPremiumAccessFeature?.frontendDesign?.highlightColor
                                     }}>
                                    <div className="purchase-price-value">
                                        {this.state.currentPremiumAccessFeature?.locallyCalculatedFields?.price}
                                        {" "}
                                        {this.state.currentPremiumAccessFeature?.locallyCalculatedFields?.currency}
                                    </div>

                                    <div className="purchase-price-value-text">
                                        {this.state.currentPremiumAccessFeature?.locallyCalculatedFields?.priceInfo}
                                    </div>
                                </div>
                                <div className="purchase-price-actions">
                                    <button
                                        className="purchase-price-info-btn"
                                        style={{
                                            background: this.state.currentPremiumAccessFeature?.frontendDesign?.backgroundColor,
                                            marginLeft: "auto",
                                            width: "100%"
                                        }}
                                        id="show-plan-info"
                                        onClick={() => this.setState({ showContractInfo: true, contractInfo: this.state.currentPremiumAccessFeature?.productDetailInformation })}
                                        type="button"
                                    >
                                        <div className={"mr-1 purchase-price-info-icon"}>
                                            <FaInfoCircle  style={{color: "white",
                                                backgroundColor: this.state.currentPremiumAccessFeature?.frontendDesign?.backgroundColor}}/>
                                        </div>
                                        <span
                                            className="purchase-info-text"
                                            dangerouslySetInnerHTML={{
                                                __html: Strings.PURCHASE_BUTTON_TEXT_MORE_INFORMATION
                                            }}
                                        />
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>
                    :
                    <div>{Strings.PURCHASE_TARIF_NO_ACTIVE_TARIF}</div>
                    }
                    {this.invoicesAndPaymentsLinkSection()}
                </div>
            </div>
        )
    }

    purchasablePremiumAccessFeatures() {
        return (
            this.state.purchasablePremiumAccessFeatures &&
            this.state.purchasablePremiumAccessFeatures?.length > 0 && (
                <div id="tt-account-plans">
                    <div className="card">
                        <div className="header">
                            <div>
                                <h4>{Strings.PURCHASE_TARIF_TARIF_SELECTION}</h4>
                                <div>
                                    <div className="segment" role="radiogroup" aria-label="Zahlungsweise">
                                        {this.state.showBillingPeriodToggleMonth &&
                                            <label id="accCycleMonthly" className={this.state.isAnnualBilling === false ? "active" : ""}
                                                   onClick={() => this.setState({isAnnualBilling: false})}>
                                                <input type="radio" name="accCycle" value="monthly"
                                                       style={{display: "none"}}/> {Strings.PURCHASE_CONFIRMATION_BUNDLE_PER_MONTH}
                                            </label>
                                        }
                                        {this.state.showBillingPeriodToggleYear &&
                                            <label id="accCycleYearly   " className={this.state.isAnnualBilling === true ? "active" : ""}
                                                   onClick={() => this.setState({isAnnualBilling: true})}>
                                                <input type="radio" name="accCycle" value="yearly"
                                                       style={{display: "none"}}/> {Strings.PURCHASE_CONFIRMATION_BUNDLE_PER_YEAR}
                                            </label>
                                        }
                                    </div>
                                    {this.state.showBillingPeriodToggleMonth && this.state.isAnnualBilling === false ? (
                                            <div className="note" id="accCycleNote">{Strings.PURCHASE_CANCEL_MESSAGE}</div>
                                        ) :
                                        <br/>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="card-grid flex-wrap justify-content-center" role="radiogroup" aria-label="Tarife">
                            {this.state.purchasablePremiumAccessFeatures
                                .filter(e => (e._embedded?.planVariant?.ContractPeriod?.unit === "year") === this.state.isAnnualBilling)
                                .map((premiumAccessFeature) => (
                                    <article className="plan" style={{background: premiumAccessFeature.frontendDesign?.backgroundColor}} key={premiumAccessFeature.id}
                                             id={`acc-plan-${premiumAccessFeature.id}`} role="radio"
                                             aria-checked={this.state.selectedPlan === premiumAccessFeature.planVariantId ? "true" : "false"}
                                             data-plan={premiumAccessFeature.id}
                                             onClick={() => this.setState({selectedPlan: premiumAccessFeature.planVariantId})}>
                                        <div>
                                            <img src={premiumAccessFeature.frontendDesign?.headerImage}
                                                 className="plan-image" alt={"plan-image"}/>
                                        </div>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: premiumAccessFeature?.checkoutDescription ?? ""
                                            }}
                                        />
                                        {premiumAccessFeature?._embedded?.planVariant?.RecurringFee > 0 && (
                                            <div className="purchase-price">
                                                <div className="purchase-price-line"
                                                     style={{
                                                         color: premiumAccessFeature?.frontendDesign?.highlightColor
                                                     }}>
                                                    <div
                                                        className="purchase-price-value"
                                                    >
                                                        {premiumAccessFeature?.locallyCalculatedFields?.price}
                                                        {" "}
                                                        {premiumAccessFeature?.locallyCalculatedFields?.currency}
                                                    </div>

                                                    <div className="purchase-price-value-text">
                                                        {premiumAccessFeature?.locallyCalculatedFields?.priceInfo}
                                                    </div>
                                                </div>
                                                <div className="purchase-price-actions">
                                                    <button
                                                        className="purchase-btn"
                                                        style={{
                                                            color: premiumAccessFeature?.frontendDesign?.backgroundColor,
                                                            backgroundColor: premiumAccessFeature?.frontendDesign?.buttonColor
                                                        }}
                                                        onClick={(e) => this.purchasePlanVariant(e)}
                                                    >
                                                        {Strings.PURCHASE_BUTTON_TEXT_SUBMIT}
                                                    </button>
                                                    <button
                                                        className="purchase-price-info-btn"
                                                        style={{
                                                            background: premiumAccessFeature?.frontendDesign?.backgroundColor
                                                        }}
                                                        id="showPlanInfo"
                                                        onClick={() => this.setState({ showContractInfo: true, contractInfo: premiumAccessFeature?.productDetailInformation })}
                                                        type="button"
                                                    >
                                                        <div className={"mr-1 purchase-price-info-icon"}>
                                                            <FaInfoCircle  style={{color: "white",
                                                            backgroundColor: premiumAccessFeature?.frontendDesign?.backgroundColor}}/>
                                                        </div>
                                                        <span
                                                            className="purchase-info-text"
                                                            dangerouslySetInnerHTML={{
                                                                __html: Strings.PURCHASE_BUTTON_TEXT_MORE_INFORMATION
                                                            }}
                                                        />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </article>
                                ))}
                        </div>
                        <div className="footer mt-4" style={{display: "flex", justifyContent: "center"}}>
                            <button
                                id="accConfirm"
                                className="btn"
                                style={{width: "250px"}}
                                onClick={(e) => this.purchasePlanVariant(e)}
                            >
                                {Strings.PURCHASE_CONFIRMATION_BUTTON}
                            </button>
                        </div>
                        <div className="hint mt-3">{Strings.PURCHASE_INFO_MESSAGE}</div>
                    </div>
                </div>
            ));
    }

    discountCodes() {
        return (
            this.state.discountCodes &&
            this.state.discountCodes.length > 0 && (
                <div id="tt-discount-codes">
                    <div className="card">
                        <div className="header">
                            <h4>{Strings.PURCHASE_DISCOUNT_CODE}</h4>
                        </div>
                        <div className="grid-discount">
                            {this.state.discountCodes.map((discount) => (
                                <article
                                    key={discount.discountCode}
                                    style={{ color: "black" }}
                                    className="plan"
                                >
                                    <div className="discount-info">
                                        <strong style={{ color: "black" }}>
                                            {Strings.PURCHASE_DISCOUNTCODE_VALIDTO}
                                        </strong>{" "}
                                        <span>
                                        {new Date(discount.endDate).toLocaleDateString("de-DE", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                        })}
                                    </span>
                                    </div>
                                    <div className="discount-info">
                                        <strong>{Strings.PURCHASE_DISCOUNTCODE_CODE}</strong>{" "}
                                        <span>{discount.discountCode}</span>
                                    </div>
                                    <div className="discount-info">
                                        <a
                                            className="discount-link-button"
                                            href={discount._links?.pointOfSale?.href || "#"}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {Strings.PURCHASE_DISCOUNTCODE_SHOPLINK}
                                        </a>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            )
        );
    }




    render() {
        return (
            <div className="premium-content-box">
                <BackButton onClick={() => this.closeView()}/>
                <br/>
                <EmailConfirmationHint accountId={this.props.accountId}/>

                {this.state.loading && (
                    <TigerSpinner/>
                )}

                {!this.state.loading && (
                    <>
                        {this.discountCodes()}
                        {this.currentActivePremiumAccessFeature()}
                        {this.purchasablePremiumAccessFeatures()}
                        {this.premiumContentByType()}
                    </>
                )}
                {this.state.showContractInfo && (
                    <InfoModal
                        text={this.state.contractInfo}
                        show={this.state.contractInfo != null}
                        size={"lg"}
                        onHide={() => this.setState({showContractInfo: false})
                    }/>
                )}
            </div>
        )
    }
}

export default withToast(Premium);